import { ContentLayout } from 'components/Layout';
import { useAuth } from 'lib/auth';
import { useEffect } from 'react';
import { Users } from 'react-feather';
import BikeIcon from 'assets/bike-icon.svg';
import { Link, useNavigate } from 'react-router-dom';
import storage from 'utils/storage';
import { MdBusiness } from 'react-icons/md';
import { ActivityFeed } from '../components/ActivityFeed';

export const Dashboard = () => {
  const { user } = useAuth();
  const navigate = useNavigate();

  console.log(user.role);
  // useEffect(() => {
  //   if (user.role !== 'ADMIN') {
  //     storage.clearToken();
  //     window.location.assign('/');
  //   }
  // }, [user]);

  // New StatsCard for quick metrics (e.g. Active Users, Live Rides, etc.)
  const StatsCard = ({ title, metric, icon }) => {
    return (
      <div className="bg-[#1E555C] shadow rounded-3xl p-4 transform hover:scale-105 transition duration-300 ease-in-out">
        <div className="flex items-center justify-between">
          <div className="text-md font-medium text-gray-200">{title}</div>
          <div className="text-gray-300">{icon}</div>
        </div>
        <div className="mt-4 text-3xl text-start text-white font-semibold">{metric}</div>
      </div>
    );
  };

  // New ActivityFeed component for recent activities

  return (
    <ContentLayout>
      <div className="text-md text-gray-600">Welcome to JustKnow Admin,</div>
      <div className="text-2xl text-gray-600 mb-8">
        {user.name || user.username} currently logged in.
      </div>

      {/* Extra Overview Components */}
      <div className="mt-12 grid grid-cols-1 md:grid-cols-5 gap-3">
        <StatsCard
          title="Users"
          metric={
            <div className="flex flex-row items-center justify-between">
              <div className="flex flex-row items-center space-x-2">
                <div className="text-xs">Active</div>
                <div className="">0</div>
              </div>
              <div className="flex flex-row items-center space-x-2">
                <div className="text-xs">New</div>
                <div className="">0</div>
              </div>
            </div>
          }
          icon={<Users size={24} />}
        />
        <StatsCard
          title="Live Rides"
          metric={0}
          icon={<img src={BikeIcon} alt="Bike Icon" className="h-6" />}
        />
        <StatsCard
          title="Total Riders"
          metric={
            <div className="flex flex-row items-center space-x-2">
              <div className="">0</div>
            </div>
          }
          icon={<MdBusiness size={24} />}
        />
        <StatsCard
          title="Total Rider Subscriptions"
          metric={
            <div className="flex flex-row items-center space-x-2">
              <div className="text-xs">UGX</div>
              <div className="">0</div>
            </div>
          }
          icon={<MdBusiness size={24} />}
        />
        <StatsCard
          title="Total Trip Fare"
          metric={
            <div className="flex flex-row items-center space-x-2">
              <div className="text-xs">UGX</div>
              <div className="">0</div>
            </div>
          }
          icon={<MdBusiness size={24} />}
        />
      </div>

      <div className="mt-12 grid grid-cols-1 md:grid-cols-2 gap-8">
        <ActivityFeed />

        <div className="bg-[#1E555C] shadow rounded-3xl p-4 transform hover:scale-105 transition duration-300 ease-in-out">
          <div className="text-xl font-bold text-gray-200 mb-4">System Alerts</div>
          <ul className="text-gray-300 text-sm space-y-2">No alerts at the moment.</ul>
          {/* <li className="border-b border-[#545a6f] pb-2">
              <span className="text-xs text-gray-400">09:15 AM</span>
              <p>New software update available.</p>
            </li>
            <li className="border-b border-[#545a6f] pb-2">
              <span className="text-xs text-gray-400">10:00 AM</span>
              <p>Payment gateway latency detected.</p>
            </li>
            <li className="border-b border-[#545a6f] pb-2">
              <span className="text-xs text-gray-400">10:30 AM</span>
              <p>Server load within acceptable range.</p>
            </li> */}
        </div>
      </div>
    </ContentLayout>
  );
};
